import { AttachFileViewDTO } from '@/types/attachment/AttachFileViewDTO';
import { HttpMethod } from '@/types/HttpMethod';
import { apiSlice } from '@/services/api/apiSlice';

/**
 * Reads of the photos of a letter. The lists themselves arrive with the letter, carrying stored
 * previews; this is the full-size read of the one photo a sender actually opens.
 */
export const attachFileApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getPhoto: build.mutation<AttachFileViewDTO, number>({
      query: (photoId: number) => ({
        url: '/attach/photo',
        method: HttpMethod.GET,
        params: {
          photoId: photoId,
        },
      }),
    }),
  }),
});

export const { useGetPhotoMutation } = attachFileApiSlice;
